module.exports = __webpack_public_path__ + "static/media/medium.d7fbff52.PNG";